import axios from 'axios';
import { useMutation, useQuery, useQueryClient } from 'react-query';

const apiUrl = () => process.env.REACT_APP_BASIX_API || '';

// item 329 — named URLs pinned to a project (documentation, config software, portals)
export interface ProjectLink {
  id: string;
  name: string;
  url: string;
}

export const useProjectLinks = (projectId: string) => useQuery<ProjectLink[]>(
  ['projectLinks', projectId],
  async () => {
    const { data } = await axios.get(`${apiUrl()}ProjectLinks/ByProject/${projectId}`);
    return Array.isArray(data) ? data : [];
  },
  { enabled: !!projectId },
);

export const useProjectLinkActions = (projectId: string) => {
  const queryClient = useQueryClient();
  const invalidate = () => queryClient.invalidateQueries(['projectLinks', projectId]);
  const add = useMutation(
    (link: { name: string; url: string }) => axios.post(`${apiUrl()}ProjectLinks`, { projectId, ...link }),
    { onSuccess: invalidate },
  );
  const remove = useMutation(
    (id: string) => axios.delete(`${apiUrl()}ProjectLinks/${id}`),
    { onSuccess: invalidate },
  );
  return { add, remove };
};

export default useProjectLinks;
